import React from 'react';
import type { ProgressProps } from 'antd';

import { Progress } from './styled.tsx';

const BaseProgress: React.FC<ProgressProps> = (props) => <Progress {...props} />;

export default BaseProgress;
